// v2 funnel API helper. Same base-URL pattern as the v1 funnel in App.js.
const BACKEND_ROOT =
  (process.env.REACT_APP_BACKEND_URL || "https://familyhealth-backend.onrender.com").replace(/\/$/, "");
const V2 = `${BACKEND_ROOT}/api/v2`;

async function request(method, path, payload) {
  const res = await fetch(`${V2}${path}`, {
    method,
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload || {})
  });
  if (!res.ok) {
    throw new Error(`v2 request failed: ${method} ${path} -> ${res.status}`);
  }
  return res.json();
}

export function createLead(payload) {
  return request("POST", "/leads", payload);
}

export function updateStep2(leadId, payload) {
  return request("PATCH", `/leads/${leadId}/step2`, payload);
}

export function updateStep3(leadId, payload) {
  return request("PATCH", `/leads/${leadId}/step3`, payload);
}

export function updateStep4(leadId, payload) {
  return request("PATCH", `/leads/${leadId}/step4`, payload);
}

export function completeLead(leadId, payload) {
  return request("PATCH", `/leads/${leadId}/complete`, payload);
}
